module.exports = __webpack_public_path__ + "img/picture20.b0c94532.png";